const LoaderLocizes = {
  LOADER_TITLE: 'Getting there',
  LOADER_DESC_1: 'Please don’t close this screen,',
  LOADER_DESC_2: 'we are taking you to the successful step',
}

export default LoaderLocizes
